module.exports = __webpack_public_path__ + "e52061aad7de4852279db6a14255570e.pdf";